module.exports = __webpack_public_path__ + "img/firewall-new.58992be.svg";